import styled, { css } from 'styled-components';

import { tokens } from '../Drawer.tokens';

interface StyledFrameProps {
    $sticky?: boolean;
}

interface StyledMainProps {
    $divided?: boolean;
}

const frameBase = css`
    position: relative;
    z-index: 2;
    flex: 0 0 auto;
`;

function stickyGradient(reverse = false) {
    // If we want a more complex "feather + blur" effect,
    // use this CodePen for reference:
    // https://codepen.io/beefchimi/pen/MWQdPGB
    return css`
        background: linear-gradient(
            ${reverse ? '180deg' : '0deg'},
            transparent,
            var(--yat_drawer-bg-color) ${tokens.section.padding}px
        );
    `;
}

export const StyledHeader = styled.div<StyledFrameProps>`
    ${frameBase}

    ${({ $sticky }) =>
        $sticky &&
        css`
            ${stickyGradient()}
            position: sticky;
            top: 0;
        `}
`;

export const StyledFooter = styled.div<StyledFrameProps>`
    ${frameBase}

    ${({ $sticky }) =>
        $sticky &&
        css`
            ${stickyGradient(true)}
            position: sticky;
            bottom: 0;
        `}
`;

export const StyledMain = styled.div<StyledMainProps>`
    --drawer-main-divider-content: none;
    position: relative;
    z-index: 1;
    flex: 1 1 auto;

    ${({ $divided }) =>
        $divided &&
        css`
            --drawer-main-divider-content: '';
        `};
`;

export const StyledSection = styled.div`
    position: relative;
    padding: ${tokens.section.padding}px;
    width: 100%;

    &:nth-child(n + 2)::before {
        content: var(--drawer-main-divider-content);
        display: block;
        position: absolute;
        top: 0;
        left: ${tokens.section.padding}px;
        right: ${tokens.section.padding}px;
        height: 1px;
        background-color: rgb(255, 255, 255, 0.1);
    }

    // TODO: Worth considering either:
    // 1. Making a <Section centered /> variant.
    // 2. Expect the consumer to pass in <Drawer.Section />.
    ${StyledHeader} &,
    ${StyledFooter} & {
        display: grid;
        align-items: center;
        justify-items: center;
    }
`;
